// Google Consent Mode v2: purpose → consent type mapping and gtag() commands.

/** `functional` is always on and is not sent to Google. */
export const CONSENT_TYPES = {
  analytics: ['analytics_storage'],
  marketing: ['ad_storage', 'ad_user_data', 'ad_personalization'],
};

/** { analytics: true, marketing: false } → { analytics_storage: 'granted', ad_storage: 'denied', … } */
export function toConsentState(granted) {
  const state = {};
  for (const purpose of Object.keys(CONSENT_TYPES)) {
    for (const type of CONSENT_TYPES[purpose]) state[type] = granted[purpose] ? 'granted' : 'denied';
  }
  return state;
}

/** Reuses `window[name]` or creates it. Null when the global exists but is not array-like. */
export function getDataLayer(win, name) {
  if (win[name] == null) win[name] = [];
  return typeof win[name].push === 'function' ? win[name] : null;
}

/**
 * gtag() bound to one dataLayer. gtag.js and GTM only treat `arguments` objects as commands,
 * so this has to stay a plain function that pushes `arguments` (not an array or rest params).
 */
export function createGtag(win, dataLayerName) {
  return function gtag() {
    const dataLayer = getDataLayer(win, dataLayerName);
    if (dataLayer) dataLayer.push(arguments);
  };
}
